import React from 'react';
import { Box, withStyles } from '@material-ui/core';
import { Modal, Typography } from '@orijinworks/frontend-commons';
import EventNoteIcon from '@mui/icons-material/EventNote';
import styles, { mainWrapperStyles, iconStyles, cancelButtonProps } from './ComingSoonModal.styles';

const ComingSoonModal = ({ open, onClose, message, classes }) => (
  <Modal
    open={open}
    onClose={onClose}
    onContinue={onClose}
    heading=""
    labelledBy="coming-soon"
    describedBy={message}
    actionBtnText="Got It"
    Icon={<EventNoteIcon sx={iconStyles} />}
    showCrossIcon
    modalType={{ type: 'normal', status: 'info', size: 'medium' }}
    showFooter
    cancelBtnText=" "
    cancelButtonProps={cancelButtonProps}
    styles={{ mainWrapperStyles }}
  >
    <Box className={classes.contentBox}>
      <Typography component="p" variant="h5" className={classes.title}>
        Coming Soon
      </Typography>
      <Typography component="p" variant="body1" className={classes.body}>
        {message}
      </Typography>
    </Box>
  </Modal>
);

ComingSoonModal.defaultProps = {
  open: false,
  onClose: undefined,
  message: 'This feature is coming soon.',
};

export default withStyles(styles)(ComingSoonModal);
